/**
 * 
 */
import { Institution } from './institution.model';
import { EducationService } from './educationService.model';
import { Building } from './building.model';
import { Territory } from './territory.model';
import { Department } from './department.model';
import { Innovation } from './innovation.model';
import { EducationContract } from './educationContract.model';
import { PublicDigitalService } from './publicDigitalService.model';
export class InstitutionFull extends Institution {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public education_services: EducationService[]; /*Образовательные услуги*/
    public buildings: Building[]; /*Здания*/
    public territory: Territory[]; /*Территория*/
    public departments: Department[]; /*Подразделения*/
    public innovations: Innovation[]; /*Инновации*/
    public education_contracts: EducationContract[]; /*Договоры на осуществление образовательной деятельности*/
    public public_digital_services: PublicDigitalService[]; /*Оказание гос. и муниципал. услуг в электронном виде*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.education_services = [];
        if (json.education_services) {
          for (const i in json.education_services) {
            if ( json.education_services.hasOwnProperty( i ) ) {
                this.education_services.push(new EducationService(json.education_services[i]));
            }
          }
        }
        this.buildings = [];
        if (json.buildings) {
          for (const i in json.buildings) {
            if ( json.buildings.hasOwnProperty( i ) ) {
                this.buildings.push(new Building(json.buildings[i]));
            }
          }
        }
        this.territory = [];
        if (json.territory) {
          for (const i in json.territory) {
            if ( json.territory.hasOwnProperty( i ) ) {
                this.territory.push(new Territory(json.territory[i]));
            }
          }
        }
        this.departments = [];
        if (json.departments) {
          for (const i in json.departments) {
            if ( json.departments.hasOwnProperty( i ) ) {
                this.departments.push(new Department(json.departments[i]));
            }
          }
        }
        this.innovations = [];
        if (json.innovations) {
          for (const i in json.innovations) {
            if ( json.innovations.hasOwnProperty( i ) ) {
                this.innovations.push(new Innovation(json.innovations[i]));
            }
          }
        }
        this.education_contracts = [];
        if (json.education_contracts) {
          for (const i in json.education_contracts) {
            if ( json.education_contracts.hasOwnProperty( i ) ) {
                this.education_contracts.push(new EducationContract(json.education_contracts[i]));
            }
          }
        }
        this.public_digital_services = [];
        if (json.public_digital_services) {
          for (const i in json.public_digital_services) {
            if ( json.public_digital_services.hasOwnProperty( i ) ) {
                this.public_digital_services.push(new PublicDigitalService(json.public_digital_services[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
